import React from "react";
import { createPortal } from "react-dom";

export default function BlockingModal({ error, message, onRetry }) {
  // Support both old (message string) and new (error object) formats for backward compatibility
  const errorData = error || { type: "generic", message: message || "An error occurred" };
  
  // Define titles and retry button text based on error type
  const getErrorConfig = (errorType) => {
    switch (errorType) {
      case "geolocation":
        return {
          title: "Geolocation Not Supported",
          retryText: null // No retry for unsupported features
        };
      case "location_permission":
        return {
          title: "Location Permission Required",
          retryText: null
        };
      case "location_unavailable":
      case "location_timeout":
      case "location_unknown":
        return {
          title: "Location Access Required",
          retryText: "Try Again"
        };
      case "mapbox_token":
        return {
          title: "Map Configuration Error",
          retryText: null
        };
      case "mapbox_load":
        return {
          title: "Map Loading Error", 
          retryText: "Retry"
        };
      default:
        return {
          title: "Error",
          retryText: "Retry"
        };
    }
  };

  const config = getErrorConfig(errorData.type);
  const shouldShowRetry = onRetry && config.retryText;

  const modal = (
    <div className="fixed inset-0 flex items-center justify-center bg-black/70 backdrop-blur-sm z-[60]">
      <div className="bg-surface-elevated rounded-lg p-6 shadow-lg w-full max-w-sm text-center">
        <h2 className="text-lg font-semibold text-text-primary mb-2">{config.title}</h2>
        <p className="text-text-secondary mb-4 whitespace-pre-line">{errorData.message}</p>
        {shouldShowRetry && (
          <button
            onClick={onRetry}
            className="px-4 py-2 bg-primary text-text-inverse rounded-md hover:bg-primary-hover transition"
          >
            {config.retryText}
          </button>
        )}
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
